<template>
  <v-dialog
    v-model="dialog"
    :overlay="false"
    persistent
    max-width="500px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="warning black--text"
        v-on="on"
        v-bind="attrs"
        :loading="isloading"
      >
        <slot> 0 Return </slot>
      </v-btn>
    </template>
    <v-card>
      <v-card-title primary-title>
        Return {{ inventory.InvName }}
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="dialog = false">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="EnvEditeForm" class="py-3">
          <v-text-field
            outlined
            readonly
            label="Item Name"
            v-model="inventory.InvName"
          ></v-text-field>
          <BaseNumInput
            outlined
            :rules="[UnitRule]"
            label="PCS QTY"
            :value="UnitQty"
            @input="OnPCInput"
          ></BaseNumInput>
          <BaseNumInput
            readonly
            outlined
            :label="inventory.UnitType + ' QTY'"
            :value="parseInt(QtyItems)"
            :suffix="ExtraPCS.toLocaleString() + '-PCS'"
          ></BaseNumInput>

          <p>{{ inventory.RPrice && inventory.RPrice.toLocaleString() }}</p>

          <v-toolbar dense class="elevation-0">
            <v-spacer></v-spacer>

            <v-btn :loading="isloading" @click="OnEdite" :disabled="!valid">
              submit
            </v-btn>
          </v-toolbar>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    EditeItems: { type: Object, required: true },
    // OnFinish: { type: Function, required: true },
  },
  data() {
    return {
      dialog: false,
      isloading: false,
      valid: true,
      inventory: {},
      UnitQty: 0,
      QtyItems: 0,
      ItemNameRule: [v => !!v || "Item Name is required"],
      QtyRule: [
        v => !!v || "Qty is required",
        // v => {
        //   if (v && !isNaN(v.replace(/,/g, "")))
        //     this.QtyItems = parseInt(v.replace(/,/g, ""));
        //   return (v && v.replace(/,/g, "")) >= 0 || `QTY ${v} is not allowed`;
        // },
      ],
      PriceRule: [v => !!v || "Price is required"],
      Stock: "/stock/Ontheway",
    };
  },
  watch: {
    // UnitQty(v) {
    //   this.$nextTick(() => {
    //     if (!isNaN(v)) this.UnitQty = parseInt(v);
    //   });
    //   // console.log(v);
    // },
    dialog(v) {
      if (v) {
        this.$nextTick(() => {
          // console.log(this.EditeItems);
          let { RQTY = 0, UnitQty } = this.EditeItems;
          this.inventory = { ...this.EditeItems };
          this.QtyItems = RQTY;

          this.UnitQty = RQTY * UnitQty;
        });
      } else {
        this.UnitQty = 0;
        this.QtyItems = 0;
        this.$refs.EnvEditeForm.resetValidation();
      }
    },
  },
  computed: {
    ExtraPCS() {
      return this.UnitQty % this.inventory.UnitQty;
    },
  },
  methods: {
    UnitRule(val) {
      if (this.QtyItems == 0 && val == 0) return "0 is not allowed";
      let val2 = val / this.inventory.UnitQty;
      let SelQty = Math.abs(this.inventory.qty);

      if (val2 > SelQty)
        return ` ${parseInt(val2)} ${this.inventory.UnitType} and ${
          this.ExtraPCS
        } PCS not equal the sold QTY (${Math.abs(parseInt(SelQty))}-${
          this.inventory.UnitType
        } and ${(SelQty * this.inventory.UnitQty) %
          this.inventory.UnitQty} PCS)`;
      return true;
    },

    OnPCInput(v) {
      let val = parseInt(v);
      let QTY = parseFloat(val / this.inventory.UnitQty);
      if (!val) this.QtyItems = 0;
      this.QtyItems = QTY;
      // console.log(QTY);

      // console.log(val % this.inventory.UnitQty);
      this.UnitQty = val || 0;
      // return val;
      // console.log(val);
    },
    OnEdite() {
      // console.log("Edited");
      this.$emit("returnQty", this.QtyItems);
      this.dialog = false;
    },
    Cancel() {
      // this.$refs.EnvEditeForm.reset();
      this.inventory = {};
      this.UnitQty = 0;
      this.dialog = false;
    },
  },
};
</script>
